var error = {
  translation: {
    error: {
      coreNotFound: 'Kunde inte hämta kärninställningar',
      domainNotAllowed: 'Registrering med e-post från denna domän är inte tillåten',
      emailAlreadyInUse: 'E-post används redan',
      insufficientPermissions: 'Otillräckliga rättigheter',
      invalidCurrentPassword: 'Fel lösenord',
      invalidPermissions: 'Välj minst en behörighet',
      invalidUsernameOrPassword: 'Ogiltigt användarnamn eller lösenord',
      localRegistrationDisabled: 'Lokal användarregistrering är inaktiverad av administratören',
      noInternetConnection: 'Ingen internetanslutning',
      noOidcProfileFound: 'Ingen OIDC-profil hittades',
      policyNotAccepted: 'Acceptera vänligen Användarvillkor och Integritetspolicy',
      registrationDisabled: 'Användarregistrering är inaktiverad av administratören',
      serverConnectionFailed: 'Anslutning till server misslyckades',
      ssoRegistrationDisabled: 'SSO-registrering är inaktiverad av administratören',
      tooManyFailedAttempts: 'För många misslyckade försök - försök igen senare',
      unknownError: 'Okänt fel, försök igen senare',
      usernameAlreadyInUse: 'Användarnamn tas',
      weakPassword: 'Starkare lösenord krävs',
    },
  },
};

export { error as default };
